import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const useRemoveGetParameters = () => {
    const history = useHistory();

    useEffect(() => () => {
        const { search } = window.location;
        const searchParams = new URLSearchParams(search);
        const newSearchParams = new URLSearchParams(search);

        searchParams.forEach((value, key) => {
            if (/^bc/.test(key)) {
                newSearchParams.delete(key);
            }
        });

        history.replace({
            search: newSearchParams.toString()
        });
    }, [history]);
};
